<div class="empty-state-container letter-spacing-0">
    <img [src]="getSrcImage()" />
    <div class="title">{{ title }}</div>
    @if (subtitle) {
    <div class="fs-12">{{ subtitle }}</div>
    }
    <div class="text {{ className }}">
        <ng-content></ng-content>
    </div>
</div>
